import { debug } from '../../../../../config';
import {getMonth, getWeekDay} from '../../../utils/date';

function getImg(popUp, img) {
  const validImg = popUp.defaultImg != '' && popUp.defaultImg != 'None';
  return validImg ? popUp.defaultImg : img;
}
function hasTicketLink(ticketLink) {
  const validTicketLink = ticketLink != 'None' && ticketLink != '';
  return validTicketLink ? true : false;
}
function getTicketLinkHtml(ticketLink) {
  const ticketLinkHtml = `<a href="${ticketLink}" class="hearby-ticketlink">Buy tickets</a>`;
  return hasTicketLink(ticketLink) ? ticketLinkHtml : '';
}
function getEventDateTime(event) {
  debug && console.log(event.dayOfWeek);
  const weekDay = getWeekDay(event.dayOfWeek);
  debug && console.log('month ', getMonth(event.month));
  const month = getMonth(event.month);
  const time = event.time;
  const day = event.day;
  return `${weekDay}, ${month} ${day}, ${time}`;
}

export {getImg, getEventDateTime, getTicketLinkHtml};
